// extracted by mini-css-extract-plugin
module.exports = {"element":"Menu_element__1NbZq","left":"Menu_left__174sN","right":"Menu_right__1uc1q"};